import { SiriusBaseComponent } from 'sirius-framework';
import { Router } from '@angular/router';
import { OnDestroy,Component } from '@angular/core';
import { LandingHomepageService } from './landing-homepage.service';
import { Images } from '../../app/shared/models/images.model'; 
import { CommonService } from '../../app/shared/service/shared.service';
import { Location } from '@angular/common';
import { Subscription } from 'rxjs';
import { SiteLanguageService } from '../shared/service/site-language.service';
import { TransactionNames } from '../../app/shared/constants/constants'
import { SharedModel } from '../../app/shared/models/shared.model';

/** String resource — boşsa Türkçe varsayılan */
const LANDING_HOMEPAGE_KEYS = {
    bannerText: 'yediEminLandingBannerText',
    bannerButtonBeforeLogin: 'yediEminLandingBannerBtnBeforeLogin',
    bannerButtonAfterLogin: 'yediEminLandingBannerBtnAfterLogin',
};

@Component({
    selector: 'landing-homepage',
    templateUrl: './landing-homepage.component.html' ,
    styleUrls: ['./landing-homepage-component.css']
})
export class LandingHomepageComponent extends SiriusBaseComponent<any> implements OnDestroy {
    subscriptionLoggedId: Subscription;
    private langSub: Subscription;
    loggedIn: boolean = false;
    public bannerText = 'Güvenli Ödeme Sistemi';
    public bannerButtonTextBeforeLogin = 'Giriş'; 
   public bannerButtonTextAfterLogin = 'Ana Sayfa'; 
    public bannerButtonLinkBeforeLogin = '';
    public bannerButtonLinkAfterLogin = '';
    _images = Images;
    isTop = true;
    constructor(private service: LandingHomepageService, private router: Router, private commonService: CommonService, private locationService: Location,
        private siteLanguage: SiteLanguageService) {
        super();
        this.commonService.notAtLoginPage.next(true);
        //this.commonService.locationService = this.locationService;
        this.commonService.urlService();
    } 

    OnInit() {
        this.commonService.headerLanguageLinkVisible.next(true);
        this.langSub = this.siteLanguage.languageCode$.subscribe(() => this.loadLandingHomepageResourceStrings());
        this.subscriptionLoggedId = this.commonService.isLoggedin.subscribe(state => {
            this.loggedIn = (state == true);
        });
    }

    private loadLandingHomepageResourceStrings(): void {
        this.bannerText = this.commonService.getStringResource(LANDING_HOMEPAGE_KEYS.bannerText, this.bannerText);
        this.bannerButtonTextBeforeLogin = this.commonService.getStringResource(LANDING_HOMEPAGE_KEYS.bannerButtonBeforeLogin, this.bannerButtonTextBeforeLogin);
        this.bannerButtonTextAfterLogin = this.commonService.getStringResource(LANDING_HOMEPAGE_KEYS.bannerButtonAfterLogin, this.bannerButtonTextAfterLogin);
    }

    ngOnDestroy() {
        if (this.langSub) {
            this.langSub.unsubscribe();
        }
        this.subscriptionLoggedId.unsubscribe();
    }

    loginButtonClick() {
        this.startTransaction('LoginFormTransaction');
    }

    mainPageButtonClick() {
        this.commonService.StartTransaction(TransactionNames.InnerMenuTransaction, SharedModel.PageName_MainInnerPage);
    }

    isScrollTop(isTop: boolean) {
        this.isTop = isTop;
    }
}
